import axios from 'axios'

export const createOBDValidationFlowId = async (request: Record<string, string>) => {
  const fetchUrl = '/portabilidadApi/obd/validation'
  const { data } = await axios.post(fetchUrl, request)
  return data
}

export const checkOBDResult = async (request: Record<string, string>) => {
  const queries = new URLSearchParams(request)
  const fetchUrl = '/portabilidadApi/obd/validation'
  const { data } = await axios.get(fetchUrl + `?${queries}`)
  return data
}

export const loginPy = async (body: Record<string, string>) => {
  const axiosUrl = '/momo/login'
  const { data } = await axios.post(`${axiosUrl}`, body)
  if (data.success) {
    return {
      success: data.success,
      response: {
        posNumber: body.posPtuNumber,
        kioskName: data.response.nombre,
        profile: data.response.perfil,
        posActivator: data.response.pos_activador,
        extCode: data.response.entidad
      }
    }
  }
  return {
    success: data.success,
    message: data.error
  }
}
